import React, {useState, useEffect, Profiler} from 'react'
import {useBeforeUnload} from 'react-router-dom'
//! Styles
import './packages.style.css'
//! Components
import Choose_Order from '../../components/chooseOrder/index'
import PackageDetail from '../../components/packageDetail/index'
import Overlay from '../../components/Overlay'
//! Helmet
import {Helmet} from "react-helmet";
//! Line Liff
import liff from '@line/liff'
import useLineLogin from '../../_actions/authLine/lineLogin';
import lineConfig from '../../_actions/authLine/lineConfig';
//! APIs
import { NhealthAction } from '../../_actions/action.api'
import { Base_API } from '../../_actions/matcher'
import { useParams } from 'react-router-dom'
import { EncryptedOBJ, DecryptedOBJ, EncryptedText, DecryptedText } from '../../utils/Encryption'

function Packages(props) {
    const { ref } = useParams();

    const [loading, setLoading] = useState(true);
    const [packSelected, setPackSelected] = useState([]);
    const [packOrder, setPackOrder] = useState([]);
    const [openDetail, setOpenDetail] = useState(false);
    const [quantitySelected, setQuantitySelected] = useState(0);
    const [campaignData, setCampaignData] = useState(null);
    const [packages, setPackages] = useState(null);
    const [pageDetail, setPageDetail] = useState({
        totalAmount: 0,
        totalPrice: '',
        promotionText: ''
    });
    const [descText, setDescText] = useState(""); // description
    const [currentRef, setCurrentRef] = useState('');

    // check
    useEffect(() => {
        if(window.localStorage.getItem('package_selected') !== null)
        {
            window.localStorage.removeItem('package_selected');
            window.location.reload();
        }
    })
    useEffect(() => {
        dataInit();
    },[])

    const dataInit = async() => {
        let currentURL = EncryptedText(String(location.href).split('?')[0]);
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL, currentURL)

        await refInit();
        removeOpenExternalPath()
        await useLineLogin(lineConfig.packages);
        let member = await checkUserInit();
        await packagesInit();
        let campaignData = await campaignInit();

        await calCartInit(campaignData,member);
        handleLoader('inactive'); 
    }

    const removeOpenExternalPath = () => {
        let pathname = location.href;
        if(pathname.indexOf('?openExternalBrowser=1') >= 0)
        {
            let newpath = pathname.replace('?openExternalBrowser=1', '');
            location.href = newpath;
        }
    }

    const refInit = () => {
        return new Promise(async resolve => {
            if(ref !== 'ref')
            {
                localStorage.setItem('refredirect', EncryptedText(ref));
            }
            resolve();
        })
    }

    const handleLoader = (status) => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;

            console.log('Line Profile: ', lineProfile);

            if(lineProfile !== null)
            {
                NhealthAction.GetMember(lineProfile.user_id)
                .then(async res => {
                    console.log('Get Member: ', res.member);
                    if(res.isSuccess === true)
                    {
                        resolve(res.member.membercode);
                    }else
                    {
                        if(res.errMessage === 'not found !.')
                        {
                            resolve(lineProfile.user_id);
                        }else
                        {
                            resolve(lineProfile.user_id);
                        }
                        // goToRegisCard();
                    }
                })
            }else
            {
                await useLineLogin(lineConfig.packages);
            }
        })
    }

    const goToRegisCard = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/welcome-card-register`;
    }

    const calCartInit = (campaignData, membercode) => {
        return new Promise(async resolve => {
            NhealthAction.CalCart(campaignData.id, 0, membercode)
            .then(res => {
                // console.log('cal cart data: ', res);
                setPageDetail({
                    ...pageDetail,
                    totalAmount: res.totalAmount,
                    totalPrice: Number(res.totalPrice).toLocaleString('th', {minimumFractionDigits: 2}),
                    promotionText: res.PromotionText
                })
                resolve();
            })
        })
    }

    const onSelectedPackage = (pack) => {
        window.location.href = `${Base_API.pathWeb}/n-health/package-detail/${pack.id}/${currentRef}`;

        // slide detail (ไม่ได้ใช้แล้ว เพราะต้องแยกหน้า Detail)
        // NhealthAction.GetPackageByID(pack.id)
        // .then(res => {
        //     let p1 = {...res, quantity_selected: 0};

        //     setOpenDetail(true)
        //     setPackSelected(p1)
        //     // console.log(p1)
        
        //     document.querySelector('body').style.overflow = 'hidden'
        // })
    }

    // Campaign Init
    const campaignInit = () => {
        return new Promise(async resolve => {
            let refRedirect = DecryptedText(localStorage.getItem('refredirect'));

            NhealthAction.GetCampaign(refRedirect).then(data => {
                let isEnd = data.isEnd;
                let isActive = data.campaign.isActive;

                if(isActive === true) // switch เปิดอยู่
                {
                    if(isEnd === false) // ยังไม่หมดเขตการขาย
                    {
                        setCampaignData(data.campaign);
        
                        // set date end
                        let p1 = String(data.appendDate).split('('); 
                        p1 = String(p1[1]).split(')');
                        p1 = Number(p1[0]);
                        localStorage.setItem('end-campaign', EncryptedText(p1));

                        let descriptionText = String(data.campaign.Description);
                        // console.log(descriptionText.replace(/[\n\r]/g, "<br/>"));
                        setDescText(`<p>${descriptionText.replace(/\n\r/g, "<br/>").replace(/\r\n/g, "<br/>")}</p>`);
        
                        resolve(data.campaign);
                    }else
                    {
                        // หมดเขตการขายแล้ว
                        endCampaign();
                    }
                }else
                {
                    endCampaign();
                }
            })
        })
    }

    // End Campaign
    const endCampaign = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/endcampaign`;
    }

    // Package Init
    const packagesInit = async() => {
        return new Promise(async resolve => {
            localStorage.removeItem('couponselected');
            localStorage.setItem('mainpage', EncryptedText('packages')); // set เพื่อเช็คในหน้าทำรายการสำเร็จว่าควรกลับมาที่หน้าไหน packages หรืิิอ nh services
    
            let refRedirect = DecryptedText(localStorage.getItem('refredirect'));
            if(!!refRedirect)
            {
                NhealthAction.GetPackages(refRedirect)
                .then(data => {
                    let p1 = data.map(item => {
                        return {...item, quantity_selected: 0}
                    })
                    // console.log('Package Data: ', data);
                    setPackages(p1);
                    resolve();
                })
                setCurrentRef(refRedirect);
            }
        })
    }

    const userInitLine = () => {
        // 1657322095-XgdlRmP4 (UAT)
        // 1657272738-BY6pb0NE (Prod)
        liff.init({ liffId: lineConfig.packages }, () => {
            if (liff.isLoggedIn()) {
              runApp();
            } else {
              liff.login();
            }
        }, err => console.error(err));
    }

    const pDetail = (
        <span dangerouslySetInnerHTML={{__html: descText}}></span> 
    )

    const runApp = () => {
        const idToken = liff.getIDToken();
        let lineProfile;
        const accessToken = liff.getAccessToken();

        // console.log('Access Token: ', accessToken);

        liff.getProfile().then(profile => {
            lineProfile = {
                id_token: idToken,
                display_name: profile.displayName,
                picture_url: profile.pictureUrl,
                status_message: profile.statusMessage,
                user_id: profile.userId,
                access_token: accessToken
            }

            window.localStorage.setItem('line_profile', EncryptedOBJ(lineProfile));
        })
    }

    // eyJhbGciOiJIUzI1NiJ9.1Lk_38JJy4polz-7Bh5Th-0YC3Sdvx2KHdgWPPmL0I-QsFRdGkSww44sff-juTH31P9PH-q3x-BSEgnzFpBDipTu2BYvqJpHp47fk9Fcq7WfycoZO_jzIMDcOPbTJKderlCH2KoqDXzk0bKI-QMIkqn45_DrtfKLIGhTQ2iaZJo.y9S_sWCDbAadg2tx3lnW45XgOtpX4BZEkoGUsZA2-W8

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="appm-packges_container">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>N Space Flash Deal | N Health</title>
                </Helmet>
                <div className="appm-packges-form_wrapper">
                    {/* cover img */}
                    <div className="appm-packges-form_banner">
                        <img src={campaignData !== null && campaignData.Cover} alt="N Health N Space Flash Deal" />
                    </div>
                    {/* header */}
                    <h1 className="appm-packages-form_header">{campaignData !== null && campaignData.Title}</h1>
                    <p className="appm-packages-promote">{pageDetail.promotionText}</p>
                    {/* <p className="appm-packges-form-sub_header">ซื้อได้ตั้งแต่วันที่ 5-12 สิงหาคม 2565<br/>
                    ใช้บริการได้จนถึง 30 กันยายน 2565</p> */}
    
                    {/* Package List */}
                    <div className="appm-packages_list-wrapper">
                        {packages !== null && packages.map((pack, i) => 
                            <div 
                                key={i}
                                className="appm-packages_list"
                                onClick={() => onSelectedPackage(pack)}
                            >
                                {/* top */}
                                <div className="appm-pl-top">
                                    {/* top (left) */}
                                    <h2 className="appm-pl_tleft">{pack.pack_type_th}</h2>
                                    {/* top (right) */}
                                    <div className="appm-pl_tright">
                                        <span>รายละเอียด </span>
                                        <i className="bi bi-chevron-right"></i>
                                    </div>
                                </div>
    
                                {/* bottom */}
                                <div className="appm-pl-bottom">
                                    {/* top (left) */}
                                    <div className="appm-pl_bleft">
                                        {/* default price */}
                                        {pack.price !== pack.flashdeal_price &&
                                            <p>฿ {Number(pack.price).toLocaleString('th')}</p> 
                                        }
                                        {/* flashdeal price */}
                                        <h3>฿ {Number(pack.flashdeal_price).toLocaleString('th')}</h3>
                                    </div>
                                    {/* top (right) */}
                                    <div className="appm-pl_bright">
                                        <button>เลือก</button>
                                    </div>
                                </div>
                            </div> 
                        )}
                    </div>

                    {/* Description */}
                    <div className="pckm-desc">
                        {pDetail}
                    </div>

                </div>
                
                {/* Package Detail */}
                <PackageDetail 
                    openDetail={openDetail} 
                    setOpenDetail={setOpenDetail} 
                    packSelected={packSelected}
                    setPackOrder={setPackOrder}
                    packOrder={packOrder}
                    quantitySelected={quantitySelected}
                    setQuantitySelected={setQuantitySelected}
                />

                {/* space */}
                <div className="appm-pck-space"></div>
    
                {/* Choose Order */}
                <Choose_Order 
                    pageDetail={pageDetail}
                    refCampaign={DecryptedText(localStorage.getItem('refredirect'))}
                    type={'packages'}
                />
    
                {/* overlay */}
                <Overlay 
                    openDetail={openDetail} 
                    setOpenDetail={setOpenDetail}
                />
            </div>
        )
    }
}

export default Packages